export default "__VITE_ASSET__ClBfx1e8__"